import fetch from '@/utils/fetch'
export function getAfantiToken() {
  return fetch({
    url: '/getAfantiToken',
    method: 'get'
  });
}
export function getInfo() {
  return fetch({
    url: '/user/info',
    method: 'get'
  });
}

export function getRemindsGet() {
  return fetch({
    url: '/user/getReminds',
    method: 'get'
  });
}

export function listMessageGet(query) {
  return fetch({
    url: '/user/listMessage',
    method: 'get',
    params: query
  });
}

export function getMessageDetailGet(query) {
  return fetch({
    url: '/user/getMessageDetail',
    method: 'get',
    params: query
  });
}

export function listFeedbackGet(query) {
  return fetch({
    url: '/user/listFeedback',
    method: 'get',
    params: query
  });
}

export function checkUserGet(query) {
  return fetch({
    url: '/user/checkUser',
    method: 'get',
    params: query
  });
}

/** 记录twp用户登录信息 */
export function saveTwpLoginLog() {
  return fetch({
    url: '/user/saveTwpLoginLog',
    method: 'get',
  })
}


export function getLeader(query) {
  return fetch({
    url: '/user/getDevelopLeadersByKeyword',
    method: 'get',
    params: query
  })
}

export function getPptidAndUserName(query) {
  return fetch({
    url: '/user/getPptidAndUserName',
    method: 'get',
    params: query
  })
}


export function userLogin(params) {
  return fetch({
    url: `${location.origin}/b/idLogin`,
    method: 'get',
    params
  });
}